module.exports = __webpack_public_path__ + "img/1.5219f1a0.jpg";